var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worldmap-nav",attrs:{"id":"worldmap-nav"}},[_c('attribute-nav',{attrs:{"selectMultiple":false,"closeOnSelect":false,"toggleable":false,"closed":false}}),_vm._v(" "),_c('CountriesRegime')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88f10a26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/navigation/PageSidebarNavigation/WorldMap.vue
// module id = 273
// module chunks = 0